import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../estilo.css';

export default function HomeHighlights() {
  const { t } = useTranslation();
  const indicatorFeatures = t('home.highlights.indicatorsFeatures', { returnObjects: true });

  return (
    <>
      <section id="indicadores" className="home-showcase home-showcase--light">
        <div className="home-showcase-inner">
          <div className="home-showcase-copy">
            <span className="section-eyebrow">{t('home.highlights.indicatorsEyebrow')}</span>
            <h2>{t('home.highlights.indicatorsTitle')}</h2>
            <p>{t('home.highlights.indicatorsText')}</p>
            <ul className="home-check-list">
              {Array.isArray(indicatorFeatures) && indicatorFeatures.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
            <Link to="/indicadores" className="qt-text-link">
              {t('home.highlights.indicatorsLink')}
            </Link>
          </div>

          <div className="home-showcase-media">
            <img
              src={require('../img/QuantumEA.png')}
              alt={t('home.highlights.indicatorsAlt')}
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section id="portfolio" className="home-showcase home-showcase--tint">
        <div className="home-showcase-inner home-showcase-inner--reverse">
          <div className="home-showcase-copy">
            <span className="section-eyebrow">{t('home.highlights.resultsEyebrow')}</span>
            <h2>{t('home.highlights.resultsTitle')}</h2>
            <p>{t('home.highlights.resultsText')}</p>
            <div className="home-result-metrics">
              <div>
                <strong>2025</strong>
                <span>{t('home.highlights.period')}</span>
              </div>
              <div>
                <strong>{t('home.highlights.views')}</strong>
                <span>{t('home.highlights.performanceRisk')}</span>
              </div>
              <div>
                <strong>MT5</strong>
                <span>{t('home.highlights.automatedStrategies')}</span>
              </div>
            </div>
            <a href="/resultados/ragnarok" className="qt-text-link">
              {t('home.highlights.resultsLink')}
            </a>
          </div>

          <div className="home-showcase-media home-showcase-media--chart">
            <img
              src={require('../img/CurvaCapitallPotifolio.png')}
              alt={t('home.highlights.resultsAlt')}
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
}
